export const SET_YEARS_DATA = 'driverManagementSystem/set-years-data';

export function setYearsData(yearsData: any) {
  return { type: SET_YEARS_DATA, yearsData };
}
